module.exports = __webpack_public_path__ + "img/big_1_30.e5543feb.png";